import G from './Getters';
import { useSelector } from 'react-redux';
import FigureImageExpansionTemplateNode from './FigureImageExpansionTemplateNode';
import { useContext } from 'react';
import LayoutValueImage from './LayoutValueImage';
import {GridCellContext} from './Contexts';
import { DragInterfaceContext } from './MouseDragProvider';
import { useState } from 'react';
import { WidthResizeContext, NodeBoundsContext } from './Contexts';
import useResolvedProperties from './useResolvedProperties';

function computeFinalDim({w,h,dw=0,dh=0}){

  let aspect = w/h;

  if( dw === 0 && dh === 0 ){
    return { w, h };
  }

  if( dw !== 0 && dh !== 0 ){
    if( w > h ){
      dh = 0;
    }else if( h >= w ){
      dw = 0;
    }
  }

  if( dw === 0 && dh !== 0 ){

    return {
      w: aspect * (h + dh),
      h: h + dh
    }

  }else if( dw !== 0 && dh === 0 ){
    return {
      w: w + dw,
      h: (w + dw) / aspect
    }
  }else if( dw !== 0 && dh !== 0 ){
    return {
      w,
      h
    }
  }


}

function getValue(){



}

function getDimensions(rawDimensions,parentBox,widthProportionOfParent){

  

  let thisDimensions = rawDimensions;




  if( !thisDimensions ){
    debugger;
  }


  let parentBoxWidth = parentBox.width;
  //let parentBoxHeight = parentBox.height;
  let thisDimW = thisDimensions.w;
  let thisDimH = thisDimensions.h;


  


  let {w,h} = computeFinalDim({
    w:parentBoxWidth * thisDimW * widthProportionOfParent,
    h:parentBoxWidth * thisDimH * widthProportionOfParent,
  })


  /*
  if( thisDimHeight > 1 ){
    ;
  }

  if( thisDimWidth > 1 ){
    ;
  }
  */



  let parentPixelDimensions = { w,h }

  return parentPixelDimensions;


}


export default function SubregionWindow({
  onItemClick,

  evaluate,
  nodeId,
  node,
  nodes,
  regions,
  parentBox,
  thumbnail,
  style,
  selected,



}){


  let cellLocation = useContext(GridCellContext);
  let annotationId = regions?.[ node?.value?.regionId ]

  let rawDimensions = useSelector(state => {
    if( annotationId ){
      return G.getAnnotationDimensions(state,{annotationId})
    }else{

      return { w:1, h:1 };
      return G.getEvaluatedExpansionNodeDimensions(state,{ figurePanelId:"fp0", cellLocation, nodeId });
    }
    

  })

  const {widthProportionOfParent=0.4} = node;

  const resolvedProperties = useResolvedProperties(
    {nodeId,cellLocation},
    {widthProportionOfParent}
  )

  let parentPixelDimensions = getDimensions(
    rawDimensions,
    parentBox,
    resolvedProperties.widthProportionOfParent
  );

  let { w,h } = parentPixelDimensions;

  return (
      <div nodeId={nodeId} 
        item={"subregion-window"}
        onClick={(e) => {
      }} class="rel" style={{
        background:'white',
        margin:style.margin,
        pointerEvents:'auto',
      }}>
        {evaluate && (
          <>
            <LayoutValueImage {...{
              style:{
                width:w,
                height:h,
              },
              nodeId,
              regionId:(node.value.regionId), 
              annotationId,
              onEvent:onItemClick,

              node,
              children:[],
              nodes,
              value:node.value,
              regions,
              parentPixelDimensions
            }}/>

          </>
        )}
        
        {!evaluate && (
          <>

            <div class="sg-row v-center h-center" style={{width:35, height:35, fontSize:10, border:'1px solid #ccc',

              }}>
                Crop
              </div>

            
          {!thumbnail && <FigureImageExpansionTemplateNode {...{
              nodeId,
              node,
              nodes,
              regions,
              value:node.value,

            }}/>}
          </>
        )}



      </div>
    )
}
